import { config } from './config';

// Registers the push service worker /sw.js (UI architecture §12). In mock mode MSW owns the worker scope, so the push
// worker stays out. Never asks a permission: that happens only from a tap (merchant screens §4.5).
export async function registerServiceWorker(): Promise<void> {
  if (config.mockMode || !('serviceWorker' in navigator)) return;
  await navigator.serviceWorker.register('/sw.js', { type: 'module' });
}
